<!--
 * @Author: liuYingBing
 * @Date: 2024-07-10 14:03:14
 * @LastEditors: liuYingBing
 * @LastEditTime: 2024-12-18 15:25:00
 * @FilePath: /fushigi/src/components/SvgIcon/src/SvgIcon.vue
 * @Description:
-->
<template>
  <svg aria-hidden="true" class="svg-icon" :width="props.size" :height="props.size">
    <use :xlink:href="symbolId" :fill="color" />
  </svg>
</template>

<script setup>
import { computed } from 'vue'
const props = defineProps({
  prefix: {
    type: String,
    default: 'icon',
  },
  name: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: '#7828FF',
  },
  size: {
    type: String,
    default: '16px',
  },
})

const symbolId = computed(() => `#${props.prefix}-${props.name}`)
</script>

<style scoped>
.svg-icon {
  vertical-align: -0.15em;
  overflow: hidden;
  fill: currentColor;
}
</style>
